import { baseTheme } from "./baseTheme";
import { brandColor } from "./brand";

/**
 * Dark-mode text uses Tailwind gray literals — not brandColor("gray", 50|300|400).
 * The brand shade generator tints from gray-500 (#6b7280), so "50" stays ~#666c7a (too dim on dark surfaces).
 */
const text = {
  fg: "#F9FAFB",
  cardFg: "#F9FAFB",
  fgSecondary: "#E5E7EB",
  fgMuted: "#D1D5DB",
  mutedFg: "#D1D5DB",
  /** Faded placeholder on fieldBg — distinct from entered text (fg) */
  placeholderFg: "#6B7280",
} as const;

export const darkThemeConfig = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    bg: brandColor("gray", 900),
    ...text,
    card: brandColor("gray", 800),
    border: "oklch(1 0 0 / 0.12)",
    muted: "oklch(1 0 0 / 0.16)",
    interactiveHover: "oklch(1 0 0 / 0.12)",
    fieldBg: brandColor("gray", 700),
    surfaceAuth: brandColor("gray", 900),
    surfaceSubtle: brandColor("gray", 900),
  },
};
